export const SELECTOR_BANK_SELECTED = (state) => state.banks.bankSelected;

export const SELECTOR_BANKS = (state) => Object.values(state.banks.banks);
